"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FluidLookup = void 0;
const fluid_country_lookup_utils_1 = require("./fluid-country-lookup.utils");
const fluid_fr_region_lookup_1 = require("./fluid-fr-region.lookup");
const fluid_uk_county_lookup_1 = require("./fluid-uk-county.lookup");
const fluid_us_state_lookup_1 = require("./fluid-us-state.lookup");
exports.FluidLookup = {
    country: fluid_country_lookup_utils_1.fluidCountryLookup,
    regional: {
        uk: fluid_uk_county_lookup_1.fluidUkCountyLookup,
        fr: fluid_fr_region_lookup_1.fluidFrRegionLookup,
        us: fluid_us_state_lookup_1.fluidUsStateLookup
    }
};
